import { motion } from "framer-motion";
import { ReactNode } from "react";
import { fadeInUp } from "../../styles/animations";

interface AnimatedSectionProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  id?: string;
}

export const AnimatedSection = ({ children, className = "", delay = 0, id }: AnimatedSectionProps) => {
  return (
    <motion.section
      id={id}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
      variants={fadeInUp}
      transition={{ delay }}
      className={className}
    >
      {children}
    </motion.section>
  );
};
